export enum EStoreIds {
  MAFUAE = "mafuae",
  MAFSAU = "mafsau",
  MAFEGY = "mafegy",
  MAFKWT = "mafkwt",
  MAFQAT = "mafqat",
  MAFPAK = "mafpak",
  MAFLBN = "maflbn",
  MAFJOR = "mafjor",
  MAFKEN = "mafken",
}

export enum EAddressFields {
  BLOCK = "block",
  BUILDING = "building",
  FLOOR = "floor",
  NUMBER = "number",
}

export enum EAddressStatus {
  DEFAULT = "default",
  UNVERIFIED = "unverified",
  OTHER = "other",
}

export enum EAddressType {
  HOME = "home",
  OFFICE = "office",
  OTHER = "other",
}

export const AREA_KEY = "Area:";
export const BLOCK_KEY = "Block#";
export const CITY_KEY = "City:";
export const FLAT_KEY = "Flat#";
export const FLOOR_KEY = "Floor#";
export const STREET_KEY = "Street#";
export const ZONE_KEY = "Zone#";
